import { html, LitElement } from "lit";
import {customElement, property} from 'lit/decorators.js';
import { when } from "lit/directives/when.js";
import {styleMap} from 'lit/directives/style-map.js';
import style from './app-header.scss';

/**
 * Application header component.
 *
 * @slot logo-img - You can insert USOS (or any else) logo here
 */
@customElement('app-header')
export class AppHeader extends LitElement {
    static override shadowRootOptions: ShadowRootInit = {
        ...LitElement.shadowRootOptions,
        delegatesFocus: true,
    };
    static override styles = style;

    /**
     * Text to display on header.
     */
    @property({attribute: 'display-name'}) displayName = '';

    /**
     * URL of image to show on the right side of header. Can be ommited.
     */
    @property({attribute: 'background-image-url'}) backgroundImageUrl = '';

    /**
     * Target URL for link on logo and header text.
     */
    @property({attribute: 'href'}) href = '';

    /** Should app width be responsive? Set by usos-layout */
    @property({reflect: true, type: Boolean}) responsive = false;

    /** Should the header be slim? This disables background image */
    @property({reflect: true, type: Boolean}) slim = false;

    override render() {
        const styles = { backgroundImage: this.backgroundImageUrl && !this.slim ? `url(${this.backgroundImageUrl})` : null };
        return html`
            <div>
                ${when(
                    this.href,
                    () => html`<a class="content" href=${this.href} style=${styleMap(styles)}>${this._renderContent()}</a>`,
                    () => html`<div class="content" style=${styleMap(styles)}>${this._renderContent()}</div>`
                )}
            </div>
        `;
    }

    private _renderContent() {
        return html`
            <slot name="logo-img"></slot>
            <span>${this.displayName}</span>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
      "app-header": AppHeader,
    }
}
